import { getLabelMessage } from '@gef-ui/localization/messages';
import Xmark from '@gef-ui/material-icons/Xmark';
import useIsTabletAndUp from '@gef-ui/material/hooks/useIsTabletAndUp';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../../utils';
const CrossIcon = styled(Xmark)(({ theme })=>({
        width: 25,
        height: 25,
        fill: theme.palette.primary.main
    }));
const COMPONENT_NAME = 'MuiCloseButton';
const CloseButton = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { onClick, size } = props;
    const isTabletAndUp = useIsTabletAndUp();
    const iconButton = /*#__PURE__*/ React.createElement(Tooltip, {
        title: getLabelMessage('errors:closeError')
    }, /*#__PURE__*/ React.createElement(IconButton, {
        size: size,
        onClick: onClick,
        id: 'close-error-button'
    }, /*#__PURE__*/ React.createElement(CrossIcon, null)));
    const button = /*#__PURE__*/ React.createElement(Button, {
        id: 'close-error-button',
        startIcon: /*#__PURE__*/ React.createElement(CrossIcon, null),
        onClick: onClick
    }, getLabelMessage('errors:closeError'));
    return isTabletAndUp ? iconButton : button;
};
CloseButton.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    size: PropTypes.string
};
export default CloseButton;
